export let Colors = {
  TopNavigation: "", // '#ec356f',
  headerTintColor: "",
  headerRightbackgroundColor: "",
  headerRightIconsColor: "",
  headerLeftTintColor: "",
  sECONDmAJORcOLORfORbUTTONS: "",
  cLEARcARTbUTTONcOLOR: "",
  ThemeBGcolor: "",
  counterButtonColors: "",
  ProgressBar: "",
  FontColor: "",
  LightBG: "",
  LightGreyScale: '',
  DarkGreyScale: '',
  GreyScale: '',
};
